import subdomainRule from './subdomain'
import {ValidationObserver} from 'vee-validate';
import {ValidationProvider} from 'vee-validate';

import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';


import { localize } from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';

// Install English locale.
localize({
    en,
});

const Plugin = {
    install(Vue, options = {}) {
        /**
         * Makes sure that plugin can be installed only once
         */
        if (this.installed) {
            return
        }

        this.installed = true

        Vue.component('ValidationObserver', ValidationObserver);
        Vue.component('ValidationProvider', ValidationProvider);

        //install all standard rule
        Object.keys(rules).forEach(rule => {
            extend(rule, rules[rule]);
        });

        subdomainRule()
    }
}

export default Plugin

